import { type ProjectCode } from '@constants'
import { type OrderItem } from '@hooks-api/types/dataModel/fpOrder'
import { type DeliveryClass } from '@hooks-api/types/dataModel/shipping'
import { Chip } from '@pets-ui/Chip/Chip'
import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import classNames from 'classnames'
import style from '../style/components/cart-item.module.scss'
import Amount from './amount'
import { VariationImg } from './variation-img'

interface Props {
  variation: OrderItem
  className?: string
  projectCode: ProjectCode
  deliveryClass: DeliveryClass
}
export const VariationComponent = (props: Props) => {
  const { variation, className = '', projectCode, deliveryClass } = props
  const wrapperClasses = classNames(style.wrapper, className)

  const isShowOriginalPrice = variation.original_price !== 0 && Number(variation.original_price) > Number(variation.sale_price)

  const isGiveaway = variation.is_giveaway && !variation.is_amount_giveaway
  const isAmountGiveaway = variation.is_amount_giveaway
  const isAddon = variation.is_addon
  const showAmount = !isGiveaway && !isAmountGiveaway

  return (
    <div className={wrapperClasses}>
      <div className={style['product-info']}>
        <VariationImg thumbnail={variation.thumbnail_url} deliveryClass={deliveryClass} productName={variation.product_name} />
        <div className={style['title-variations']}>
          <HStack alignItems="center" gap={1} mb={1}>
            {isAddon && <Chip size="small" variant="square" color="green">加價購</Chip>}
            {isAmountGiveaway && <Chip size="small" variant="square" color="green">滿額禮</Chip>}
            {isGiveaway && <Chip size="small" variant="square" color="green">贈品</Chip>}
            <Text variant="subtitle">{variation.product_name}</Text>
          </HStack>
          <div className={style.variations}>
            {variation.attributes && Object.values(variation.attributes).map(attr => (
              <div key={attr.key}>{attr.value}</div>
            ))}
          </div>
        </div>
      </div>
      <div className={style['price-qty']}>
        {showAmount
          ? (
            <div className={style.prices}>
              <Amount
                className={`${style.price} ${projectCode?.toLowerCase()}`}
                amount={variation.sale_price ?? 0}
              />
              {isShowOriginalPrice && (
                <Amount className={style['original-price']} amount={variation.original_price ?? 0} />
              )}
            </div>
          )
          // NOTE: div for space-between
          : <div />}
        <span>
          x
          {variation.quantity}
        </span>
      </div>
    </div>
  )
}
